export default __webpack_public_path__ + "static/media/empty_section.20ed629f.svg";